/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable i18next/no-literal-string */
import { createExperiment } from './framework';

// An ongoing A/A test to make sure the framework is capturing good
// data. More info: https://blog.hubspot.com/marketing/aa-test
// started: 2021-10-19, ended: 2021-12-16
// results: https://dutchie.atlassian.net/wiki/spaces/EN/pages/409436555
export const aaTest = createExperiment('aa_test');

// started: 2022-02-16, ended: 2022-03-16
// results: https://docs.google.com/presentation/d/1yrb_kGdSQuAhZHeEKDGrAIoPSPX2RYUg_a5ayGZ1wkY

// started: 2022-04-05, ended: 2022-05-18
// results: https://docs.google.com/presentation/d/1yrb_kGdSQuAhZHeEKDGrAIoPSPX2RYUg_a5ayGZ1wkY/edit?usp=sharing
const mostPurchasedProductsTest = createExperiment('most_purchased_products', {
  experimentRate: 0.5,
});

// started: 2022-04-15
export const pdpRecsVendorTest = createExperiment('pdp_recs_vendor', {
  experimentRate: 0.5,
});
